import { render, staticRenderFns } from "./CompaniesArchived.vue?vue&type=template&id=9f72a33e"
import script from "./CompaniesArchived.vue?vue&type=script&lang=js"
export * from "./CompaniesArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports